import { Breadcrumbs, Toolbar } from '@exxonmobil/react-unity';
import React from 'react';
import { numberMillify } from '../../common/utils/numberUtil';

interface Props {
  domainCount: number;
  endpointCount: number;
  consumerCount: number;
  volumeCount: number;
}

export const EndpointFooter = ({ domainCount, endpointCount, consumerCount, volumeCount }: Props) => (
  <Toolbar>
    <Toolbar.Item>
      <Breadcrumbs id="disable" style={{ marginBottom: 0 }}>
        <Breadcrumbs.Item> {domainCount} Domains </Breadcrumbs.Item>
        <Breadcrumbs.Item> {endpointCount} Endpoints </Breadcrumbs.Item>
        <Breadcrumbs.Item> {consumerCount} Unique consumers </Breadcrumbs.Item>
        <Breadcrumbs.Item> {numberMillify(volumeCount)} Volume </Breadcrumbs.Item>
      </Breadcrumbs>
    </Toolbar.Item>
  </Toolbar>
);
